// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronDown: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10">
            <path
                fill="currentColor"
                d="M13.7509763,8.74706984 C13.431133,8.74706984 13.1111324,8.62499952 12.8673828,8.3808589 L7.50097632,3.0166012 L2.13378906,8.38378906 C1.64550781,8.87207031 0.854492188,8.87207031 0.366210938,8.38378906 C-0.122070313,7.89550781 -0.122070313,7.10449219 0.366210938,6.61621094 L6.61621094,0.366210938 C7.10449219,-0.122070312 7.89550781,-0.122070312 8.38378906,0.366210938 L14.6337891,6.61621094 C15.1220703,7.10449219 15.1220703,7.89550781 14.6337891,8.38378906 C14.3916011,8.62597585 14.0712893,8.74706984 13.7509763,8.74706984 Z"
                transform="matrix(1 0 0 -1 -.001 9.253)"
            />
        </svg>
    );
};

export default React.memo(ChevronDown);
